<div class="content-header">
  <h1>Events Management</h1>
  <div class="header-actions">
    @if (authStore.canEdit() && clientData && !clientData.isGroupLinkEnabled) {
      <sdc-button
        variant="secondary"
        [attr.data-cy]="'event-private-selling-button'"
        (onClick)="onPrivateSellingClick()">
        <ng-icon name="lucideShield" aria-hidden="true" />
        <span>
          {{
            clientData.isPrivateSellingEnabled
              ? 'Manage private selling'
              : 'Start private selling'
          }}
        </span>
      </sdc-button>
    }
    <sdc-button
      variant="secondary"
      [class.toolbar-inactive]="!queryParams.future"
      (onClick)="toggleFuture()">
      <ng-icon name="lucideCheck" aria-hidden="true" />
      <span>On going events only</span>
    </sdc-button>

    @if (authStore.canEdit()) {
      <sdc-button variant="success" (onClick)="refreshEvents()">
        <ng-icon name="lucideRefreshCw" aria-hidden="true" />
        <span>Refresh Events</span>
      </sdc-button>
    }
  </div>
</div>

<div class="toolbar">
  <form class="event-search" (submit)="onSearchSubmit($event)">
    <sdc-input
      name="event-search"
      placeholder="Search event using code"
      [control]="searchControl"
      [attr.data-cy]="'event-search-input'" />
    <div class="search-actions">
      <sdc-button
        variant="glass"
        size="sm"
        type="submit"
        [attr.data-cy]="'event-search-button'">
        <span>Search</span>
        <ng-icon name="lucideSearch" aria-hidden="true" />
      </sdc-button>
      @if (activeSearch) {
        <sdc-button variant="secondary" (onClick)="restoreTable()">
          Clear
        </sdc-button>
      }
    </div>
  </form>
  @if (
    authStore.canEdit() && (eventsService.selectedEventsIds | async);
    as selectedEventsIds
  ) {
    <sdc-button
      variant="secondary"
      [class.toolbar-inactive]="
        !eventsLists?.length || !selectedEventsIds?.length
      "
      (onClick)="onEditBulkClick()">
      Edit all selected
    </sdc-button>
  }
  <p class="refresh-events-disclaimer">
    By refreshing the events you will pull all the events that the MMC Agency
    has access to in ProVenue.
  </p>
</div>

@if (refreshing) {
  <div class="loading">
    <div class="text-container">
      <div>
        <span>Loading new events</span>
      </div>
      <div>
        <div class="dot-typing"></div>
      </div>
    </div>
  </div>
}
@if (eventsLists?.length === 0) {
  <div class="not-found">
    <span>No events found. Refresh events or check the used code.</span>
  </div>
}
@if (eventsLists?.length !== 0) {
  <gs-table
    [data]="eventsLists"
    [columns]="columns"
    [pinningHeaders]="true"></gs-table>
}
<p class="legend">
  Showing {{ eventsLists?.length }} of {{ totalItemsInDb }} total Events
</p>
<app-pagination
  [totalItemsInDb]="totalItemsInDb"
  [itemsPerPage]="itemsPerPage"></app-pagination>
